import styled from 'styled-components'
import { colorTheme } from '../../../style/theme/colorTheme'
import { theme } from '../../../style/theme'

export const DrawerContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1em;
	padding: 0 1em 1.5em 1em;
	width: 100%;

	@media screen and (max-width: ${theme.point820}) {
		max-width: 25em;
		margin: 2.6em auto 0;
	}
`
DrawerContent.displayName = 'DrawerContent'

export const IconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 7.5em;
	height: 7.5em;
	border: 1px solid transparent;
	border-radius: 1.25em;
	flex-shrink: 0;

	> svg {
		width: 4em;
		height: 4em;
	}

	&.neutral {
		background-color: ${colorTheme.watch.iconArea.neutralBackground};
		border-color: ${colorTheme.watch.iconArea.neutralBorder};
		color: ${colorTheme.watch.iconArea.neutralIcon};
	}

	&.blue {
		background-color: ${colorTheme.watch.iconArea.blueBackground};
		border-color: ${colorTheme.watch.iconArea.blueBorder};
		color: ${colorTheme.watch.iconArea.blueIcon};
	}

	&.green {
		background-color: ${colorTheme.watch.iconArea.greenBackground};
		border-color: ${colorTheme.watch.iconArea.greenBorder};
		color: ${colorTheme.watch.iconArea.greenIcon};
	}

	&.red {
		background-color: ${colorTheme.watch.iconArea.redBackground};
		border-color: ${colorTheme.watch.iconArea.redBorder};
		color: ${colorTheme.watch.iconArea.redIcon};
	}
`
IconContainer.displayName = 'IconContainer'

export const StateHeading = styled.h3`
	font-size: 1.25em;
	font-weight: 700;
	margin: 0;
	text-align: center;
	color: ${colorTheme.watch.heading};
`
StateHeading.displayName = 'StateHeading'

export const StateSubtext = styled.p`
	font-size: 0.875em;
	color: ${colorTheme.watch.subtext};
	text-align: center;
	margin: 0;
`
StateSubtext.displayName = 'StateSubtext'

export const CodeLabel = styled.span`
	font-size: 0.75em;
	color: ${colorTheme.watch.subtext};
	font-weight: 600;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	align-self: flex-start;
`
CodeLabel.displayName = 'CodeLabel'

export const CodeFieldBox = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	border: 1.5px solid ${colorTheme.watch.codeField.border};
	border-radius: 0.75em;
	padding: 0.5em 0.75em;
	gap: 0.5em;
`
CodeFieldBox.displayName = 'CodeFieldBox'

export const CodeValue = styled.span`
	font-size: 2.25em;
	font-weight: 500;
	font-family: 'Roboto', sans-serif;
	letter-spacing: 0.05em;
	color: ${colorTheme.watch.codeField.value};
`
CodeValue.displayName = 'CodeValue'

export const CopyButton = styled.button`
	display: flex;
	align-items: center;
	gap: 0.375em;
	background-color: ${colorTheme.watch.copyButton.background};
	color: ${colorTheme.watch.copyButton.text};
	border: none;
	border-radius: 0.5em;
	padding: 0.5em 0.875em;
	font-size: 0.875em;
	font-weight: 600;
	cursor: pointer;
	white-space: nowrap;
	flex-shrink: 0;

	> svg {
		width: 1.5em;
		height: 1.5em;
	}

	&:hover {
		background-color: ${colorTheme.watch.copyButton.backgroundHover};
	}
`
CopyButton.displayName = 'CopyButton'

export const InfoBox = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 0.5em;
	width: 100%;
	border: 1.5px solid ${colorTheme.watch.infoBox.border};
	border-radius: 0.625em;
	padding: 0.75em;
	font-size: 0.8em;
	color: ${colorTheme.watch.infoBox.text};

	> svg {
		flex-shrink: 0;
		width: 1.5em;
		height: 1.5em;
		margin-top: 0.0625em;
		color: ${colorTheme.watch.infoBox.icon};
	}
`
InfoBox.displayName = 'InfoBox'

export const TimerRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	font-size: 0.8em;
	color: ${colorTheme.watch.timer.text};
`
TimerRow.displayName = 'TimerRow'

export const ProgressTrack = styled.div`
	width: 100%;
	height: 0.375em;
	background-color: ${colorTheme.watch.timer.track};
	border-radius: 0.1875em;
	overflow: hidden;
`
ProgressTrack.displayName = 'ProgressTrack'

export const ProgressFill = styled.div.attrs(props => ({
	style: { width: `${props.$pct != null ? props.$pct : 100}%` },
}))`
	height: 100%;
	background-color: ${colorTheme.watch.timer.fill};
	border-radius: 0.1875em;
	transition: width 0.9s linear;
`
ProgressFill.displayName = 'ProgressFill'

export const DeviceCard = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.625em;
	width: 100%;
	text-align: left;
	border: 1.5px solid ${colorTheme.watch.deviceCard.border};
	border-radius: 0.75em;
	padding: 0.75em 1em;

	> svg {
		flex-shrink: 0;
		width: 1.5em;
		height: 1.5em;
		color: ${colorTheme.watch.deviceCard.icon};
	}
`
DeviceCard.displayName = 'DeviceCard'

export const DeviceName = styled.span`
	display: block;
	font-weight: 700;
`
DeviceName.displayName = 'DeviceName'

export const ButtonsGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.625em;
	width: 100%;
`
ButtonsGroup.displayName = 'ButtonsGroup'
